// eslint-disable-next-line
export const setFilters = {
  methods: {
    getFilteredValue(value) {
      if (Array.isArray(value) && value.length) {
        if (typeof value[0] === 'object') {
          const array = [];
          value.forEach((obj) => {
            array.push(obj.id);
          });
          return array.join(',');
        }
        return value.join(',');
      }
      return value;
    },
    setFilters(filters) {
      let filtersAll = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          const filter = { [key]: this.getFilteredValue(value) };
          filtersAll = Object.assign(filtersAll, filter);
        }
      });
      if (Object.keys(filtersAll).length) {
        const queryUrl = [];
        Object.entries(filtersAll).forEach(([key, value]) => {
          queryUrl.push(`${key}=${value}`);
        });
        if (`${this.$route.path}?${queryUrl.join('&')}` === this.$route.fullPath) {
          this.loadAllRequests();
          return;
        }
        this.$router.push({
          to: this.$route.name,
          query: {
            ...filtersAll,
          },
        });
      } else if (Object.values(this.$route.query).length) {
        this.$router.push({
          to: this.$route.name,
        });
      }
    },
  },
};
